import * as React from "react";

import { ScrollContext } from "~/layout/ScrollContext";

import AsanaIntegration from "../Integrations/Asana/AsanaIntegration";
import HubspotIntegration from "../Integrations/Hubspot/HubspotIntegration";
import MicrosoftTodoIntegration from "../Integrations/MicrosoftTodo/MicrosoftTodoIntegration";
import SalesforceIntegration from "../Integrations/Salesforce/SalesforceIntegration";
import ZapierIntegration from "../Integrations/Zapier/ZapierIntegration";
import UserIntegrationsHome, { type IntegrationSubpageKey } from "../UserIntegrations";

import styles from "./Integrations.module.css";

const { useCallback, useContext, useLayoutEffect, useState } = React;

interface Props {
	defaultIntegration?: IntegrationSubpageKey;
}

export default function Integrations({ defaultIntegration }: Props) {
	const [integration, setIntegration] = useState<IntegrationSubpageKey | undefined>(defaultIntegration);

	const goBack = useCallback(() => {
		setIntegration(undefined);
	}, []);

	const scrollRef = useContext(ScrollContext);
	useLayoutEffect(() => {
		scrollRef?.scrollTo(0, 0);
	}, [scrollRef, integration]);

	return (
		<div className={styles.main}>
			{integration === "zapier" ? (
				<ZapierIntegration onBackClick={goBack} />
			) : integration === "asana" ? (
				<AsanaIntegration onBackClick={goBack} />
			) : integration === "microsoft-todo" ? (
				<MicrosoftTodoIntegration onBackClick={goBack} />
			) : integration === "salesforce" ? (
				<SalesforceIntegration onBackClick={goBack} />
			) : integration === "hubspot" ? (
				<HubspotIntegration onBackClick={goBack} />
			) : (
				<UserIntegrationsHome onSelectSubpage={setIntegration} />
			)}
		</div>
	);
}
